import { useEffect, useRef } from 'react';
import settingsHtml from '../../html/views/settings.html?raw';
import { initSettingsView } from '../../settings/init';

/**
 * Settings view — teams (CRUD for admins) and read-only user roster from Checkpoint.
 */
export function SettingsView({ onBack }: { onBack: () => void }) {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        initSettingsView();
    }, []);

    return (
        <div className="px-3 py-4">
            <div className="d-flex align-items-center gap-2 mb-4">
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={onBack}
                >
                    <i className="ti ti-arrow-left me-1" /> Back
                </button>
                <h3 className="h5 mb-0">Settings</h3>
            </div>

            <div
                ref={containerRef}
                dangerouslySetInnerHTML={{ __html: settingsHtml }}
            />
        </div>
    );
}
